import type { LabeledValue } from "@volumental/common";

export function findWithFallback<T>(needle: T, haystack: LabeledValue<T>[]): LabeledValue<T> {
  return (
    haystack.find((item) => item.value === needle) ?? {
      value: needle,
      label: String(needle),
    }
  );
}
